import React, { useEffect, useState } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Textfield from "../../components/formikcomponent/TextField";
import File from '../../components/formikcomponent/Imageinput';
import {string, mixed, array, object} from 'yup';
import {StatusCodes} from 'http-status-codes';
import JsonPreview from '../PreviewTrivia';
import ChapterPreview from './CurriculumPreview';
import { Typography, makeStyles, Button, Grid, Paper,Tooltip,withStyles } from '@material-ui/core';
import { Formik, Field, Form, FieldArray } from "formik";
import Card from '../../components/Card/Card';
import DeleteIcon from '@material-ui/icons/Delete';
import DiseaseSegment from'../../components/Fields/DiseaseSegment';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import Resourceid  from '../../components/Fields/Resource';
import Persona from'../../components/Fields/Persona';
import ErrorDialog from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fieldtext from '../../components/Fields/FieldText';
import Constants from '../../components/Fields/DropDownList';
import Trigger from '../../components/Fields/Trigger';
import CategoryTag from '../../components/Fields/CategoryTag';
import TopicTag from '../../components/Fields/TopicTag';
import AreaField from '../../components/Fields/VeevaContentId';
import { AFBCUR } from "../../components/CSSDuplicatedBlocks";
import { v4 as uuidv4 } from "uuid";
const bgcolor2 = "rgb(243, 244, 245)";
const useStyles = makeStyles(theme => ({
  createUser: {
    width: "230px", color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
    borderRadius: "50px", margin: "8px 10px", padding: "7px 20px", textTransform: "uppercase", marginTop: "-2px", '&:hover': {
      backgroundColor: theme.palette.hoverPrimaryColor.main,
      color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`,
    },
    [theme.breakpoints.down("sm")]: { width: "80%", marginLeft: "10px", }
  },
  successDialogOK: {
    color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
    borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 15px", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` }
  },
  lightTooltipTimeToTake: {
    maxWidth: 150,
    minWidth: 150,
    color: 'rgba(74, 74, 74, 1)',
    fontSize: 12,
    border: '1px solid #dadde9',
    boxShadow: "0px 1px 0px -6px rgba(0,0,0,0.2), 0px 1px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
  }, errormessage: { color: "#f44336", fontSize: " 0.75rem", paddingTop: "3px" },
  DeleteUser: {
    '&:hover': { color: bgcolor2, border: "1px solid " },
    [theme.breakpoints.down("sm")]: {
      top: "-90px"
    },
    border: "none",
    backgroundColor: bgcolor2,
    borderRadius: "50%",
    position: "absolute", right: "6px",
    padding: "8px",
  },
  fieldarraypadding: { paddingTop: "30px" },
  cancelBtn: {
    width: "230px", height: "40px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)", color: "rgba(75, 123, 227, 1)",
    borderRadius: "25px", border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
    '&:hover': { color: '#1d5d90', border: "1px solid " }, [theme.breakpoints.down("sm")]: { width: "80%", marginLeft: 0 }
  },
  adherencePopBdy: {
    padding: "1px",
  },
  chapterheading: {
    backgroundColor: bgcolor2, height: "80px", [theme.breakpoints.down("sm")]: {
    }
  },
  gridHeader: { paddingLeft: "5px", paddingBottom: "25px", paddingTop: "5px" },
  clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "17px" },
  button: {
    height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", color: "white", paddingTop: "7px", width: '100%', paddingBottom: "7px",
    fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer", borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { opacity: '0.8', transition: '0.2s', backgroundColor: '#2262bf' }
  },
  ...AFBCUR
}));

const AddCurriculum = (props) => {
  const [open, setOpen] = useState(false);
  const [openpop, setOpenpop] = useState(false);
  const [openpopup, setOpenpopup] = useState(false);
  const [chapterpreviewdata, setChapterPreviewdata] = useState();
  const [newchapterpreview, setNewchapterpreview] = useState(false);
  const [SucessFieldcur, setSucessfieldcur] = useState(false);
  const [Errorclosecur, setErrorClosecur] = useState(false);
  const [load, setLoad] = useState(false);
  const [UpdatedMessage, setUpdatedMessage] = useState("");
  const[disablecursubmit,setDisablecurSubmit]= useState(false);
  const [ImageErrorclosecur, setImageErrorClosecur] = React.useState(false);
   const [curriculumdata, setCurriculumdata] = useState({
            chapter: [
                {
                    title: "",
                    chapterid: 0,
                    screen: [
                        {
                            type: "text",
                            image:"",
                            title: "",
                            screenid: 1,
                            description: "",
                            displayorder: 1
                        }
                    ],
                    chapterimage:"",
                    displayorder: 1
                }
            ],
           content: {
            introductionmessage: "",
            courseimage:"",
            coursetitle: "",
            conclusionmessage: "",
            courseid: 0,
            displayorder:1,
           },
            isdeleted: 0,
            resourceid: "",
            type: 4,
            title: [" "],
            category: null,
            trigger: [],
            categorytag: [],
            topictag: [],
            topicid: null,
            diseasesegment: [],
            persona: []
    });
  const requiredMessage = "This field is required.";
  const max100 = "max 100 charater";
  const max500 = "max 500 charater";
  let validateWithSchema = object().shape({
    chapter: array().of(object().shape({
      chapterimage: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
      title: string().max(StatusCodes.CONTINUE, max100).required(requiredMessage),
      screen: array().of(object().shape({
        image: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
        title: string().max(StatusCodes.CONTINUE, max100).required(requiredMessage),
        description: string().required(requiredMessage).max(StatusCodes.INTERNAL_SERVER_ERROR, max500),
      })),
    })),
    content: object().shape({
      courseimage: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
      introductionmessage: string().max(StatusCodes.INTERNAL_SERVER_ERROR, max500).required(requiredMessage),
      coursetitle: string().max(StatusCodes.CONTINUE, max100).required(requiredMessage),
      conclusionmessage: string().max(StatusCodes.INTERNAL_SERVER_ERROR, max500).required(requiredMessage),
    }),
    categorytag: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
    topictag: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
    trigger: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
    resourceid: string().required(requiredMessage),
    diseasesegment: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
    persona: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string() .typeError(requiredMessage), }).required(requiredMessage),
  });
let triggercurValue=Constants.triggeroption;
let categorytagValue=Constants.categoryValue;
let TopictagcurrValue=Constants.TopictagValue;
let diseaseSegmentcurrValue=Constants.diseaseSegmentValue;
let personaCurValue=Constants.personaValue;
 const classes = useStyles();
 let  SuccessMessage = "Curriculum Content has been created successfully.";
  let errorMessage1 = "Please check Content ID already exit.";
useEffect(()=>{
  setUpdatedMessage("Curriculum Content has been Updated successfully.");
  if(props.location.clone === "clone"){
    setUpdatedMessage(SuccessMessage);
  }
 if(chapterpreviewdata){
setNewchapterpreview(true);
 setOpen(true);
}
},[chapterpreviewdata]);
 useEffect(()=>{

   const Updatedata = (value, label) => {
     let comingvalue = [];
     for (let i = 0; i < value.length; i++) {
     label.find((val) => {
       if (val.label === value[i]) {
         comingvalue.push({ value: val.value, label: val.label });
       }
     });
     }
     return comingvalue;
   };
   if (props.location.state) {
     if (props.location.state.detail) {
       curriculumdata.categorytag = Updatedata(props.location.state.detail[0].categorytag, categorytagValue);
       curriculumdata.trigger = Updatedata(props.location.state.detail[0].trigger, triggercurValue);
       curriculumdata.topictag = Updatedata(props.location.state.detail[0].topictag, TopictagcurrValue);
       if(props.location.clone !== "clone"){
        curriculumdata.resourceid = props.location.state.detail[0].resourceid;
      }
       curriculumdata.content.introductionmessage = props.location.state.detail[0].content.introductionmessage;
       curriculumdata.content.coursetitle = props.location.state.detail[0].content.coursetitle;
       curriculumdata.content.courseimage = props.location.state.detail[0].content.courseimage;
       curriculumdata.content.conclusionmessage = props.location.state.detail[0].content.conclusionmessage;
      if(props.location.newversion_clone){
       curriculumdata.veevacontentid = props.location.state.detail[0].veevacontentid;}
       curriculumdata.content.courseid = props.location.state.detail[0].content.courseid;
       curriculumdata.content.displayorder = props.location.state.detail[0].content.displayorder;
       curriculumdata.diseasesegment = Updatedata(props.location.state.detail[0].diseasesegment, diseaseSegmentcurrValue);
       curriculumdata.persona = Updatedata(props.location.state.detail[0].persona, personaCurValue);
        if(props.location.state.detail[0].versionNumber!==props.location.state.detail[0].Version.newversion&&props.location.clone !== "clone"){
setDisablecurSubmit(true);
}
       if (props.location.state.detail[0].chapter) {
         let chapterdata = [];
         props.location.state.detail[0].chapter.map((chapter, index) => {
           let screendata = [];
           props.location.state.detail[0].chapter[index].screen.map((screen) => {
             screendata.push({
               title: screen.title,
               type: "text",
               image: screen.image,
               screenid: screen.screenid,
               description: screen.description,
               displayorder: screen.displayorder
             });
           });
           chapterdata.push({
             chapterid: chapter.chapterid,
             title: chapter.title,
             displayorder: chapter.displayorder,
             chapterimage: chapter.chapterimage,
             screen: screendata
           });
         });
         curriculumdata.chapter = chapterdata;
       }
     } else {
       curriculumdata.content.displayorder = props.location.state.length + 1;
     }
   }
 setCurriculumdata(curriculumdata);
},[]);
 const handleClose = () => {
    setOpen(false);
    setOpenpopup(false);
  };

const handleClosechapter= () => {
 setOpen(false);
 setNewchapterpreview(false);
setChapterPreviewdata();
};
 const handlePreview = () => {
    setOpen(true);
    setOpenpopup(true);
  };
let errorMessage = "Below are the example of supported Rich Text HTML tags";
let Message="For Bold tag  <b>text</b>, For Italic tag  <i>text</i>, For Underline  <u>text</u>, For Link tag  <a href='url'>link text</a>, Unordered list, Ordered list ";
const handlepop = () => {
   setOpenpop(true);
  };
const handleCloseDialog = () => {
   setOpenpop(false);
  };
const handleCloseDialogcur = () => {
      setOpen(false);
      setSucessfieldcur(false);
    props.history.push("/Home/Curriculum");
  };
 const  handleErrorUsercur = () => {
    setOpen(false);
    setErrorClosecur(false);
    setOpenpop(false);
    setImageErrorClosecur(false);
  };
const imageerror=()=>{
  setOpen(false);
setImageErrorClosecur(true);
};
const imageerrormessage="Images are not saved, Please submit again";
const InactivatePatientButton = [<Button className={classes.successDialogOK} onClick={handleCloseDialogcur}>{"OK"}</Button>];
const InactivatePatientButton1 = [<Button className={classes.successDialogOK} onClick={ handleErrorUsercur}>{"OK"}</Button>];

const sendSucesscur = () => {
    setOpen(true);
    setSucessfieldcur(true);
  };
  const sendErrorcur = () => {
    setOpen(true);
    setErrorClosecur(true);
  };

  const handleDisable = () => {
    if(props.location.clone === "clone"){
      return false;
    }
    if(props.location.state.detail){
      return true;
    }
    return false;
  };
  return(
    <div><Typography className={classes.heading} component="h5">Curriculum Form</Typography>
    <Formik
        enableReinitialize={true}
        validator={() => ({})}
        validationSchema={validateWithSchema}
        initialValues={curriculumdata}
        onSubmit={(values, actions) => {
          setLoad(true);
          if (values.chapter) {
            values.chapter.map((chapter, index) => {
              values.chapter[index].chapterid = index + 1;
              values.chapter[index].displayorder = index + 1;
              values.chapter[index].screen.map((screen, index1) => {
                values.chapter[index].screen[index1].screenid = index1 + 1;
                values.chapter[index].screen[index1].displayorder = index1 + 1;
              });
            });
            values.content.courseid = values.resourceid;
            actions.setValues({ ...values });
          }
          let sendingCurrvalue = ({ ...values, content: { ...values.content }, chapter: [...values.chapter] });
          if(props.location.state.detail){
            const idToMap = props.location.state.detail[0].chapter;
            idToMap.map((item, i) => {
              sendingCurrvalue.chapter[i].id = item.id;
            })
          };
          const Getcurvalue = (value) => {
            let trigger = [];
            value.map((obj) => {
              trigger.push(String(obj.label));
            });
            return trigger;
          };

          sendingCurrvalue.diseasesegment = Getcurvalue(values.diseasesegment);
          sendingCurrvalue.persona = Getcurvalue(values.persona);
          sendingCurrvalue.categorytag = Getcurvalue(values.categorytag);
          sendingCurrvalue.topictag = Getcurvalue(values.topictag);
          sendingCurrvalue.trigger = Getcurvalue(values.trigger);
          let resdata = [];
          let count = 0;
          let imagesnotsend = true;
          let data = new FormData();
          const CURRICULUM = "Curriculum&";
          if (values.content.courseimage.base64Rep) {
            data.append(`imagefile`, values.content.courseimage, `${CURRICULUM + values.resourceid + "_" + uuidv4() + "_courseimage.jpg"}`);
            imagesnotsend = false;
          }
          if (values.chapter) {
            values.chapter.map((chapter, index) => {
              if (values.chapter[index].chapterimage.base64Rep) {
                data.append(`imagefile`, values.chapter[index].chapterimage, `${CURRICULUM + values.resourceid + "_chapterimage_" + uuidv4() + ".jpg"}`);
                imagesnotsend = false;
              }
              values.chapter[index].screen.map((screen, index1) => {
                if (values.chapter[index].screen[index1].image.base64Rep) {
                  data.append(`imagefile`, values.chapter[index].screen[index1].image, `${CURRICULUM + values.resourceid + "_image_screen_" + uuidv4() + ".jpg"}`);
                  imagesnotsend = false;
                }
              });
            });
          }
          async function sendCurriculumdata() {
            let urlsend = "";
            urlsend = "/api/content/contentservice/saveCurriculumResource";
            if(props.history.location.pathname.includes("revision") && props.location.clone !== "clone"){
              urlsend = "/api/content/contentservice/createRevisionForCurriculumResource";
            }
            if(props.history.location.pathname.includes("version") && props.location.clone !== "clone"){
              urlsend = "/api/content/contentservice/createVersionCurriculumForResource";
            }
            let responsesend = await props.authenticatedApiCall("post", urlsend, sendingCurrvalue);
            setLoad(false);
            if (responsesend && responsesend.status === StatusCodes.OK) {
              sendSucesscur();
            }
            if (responsesend && responsesend.status === StatusCodes.BAD_REQUEST) {
              sendErrorcur();
            }
          }
          if(props.location.state){
            if(props.location.state.detail){
              sendingCurrvalue.id = props.location.state.detail[0].id;
            }
          }
          if (imagesnotsend) {
            sendCurriculumdata();
          }
          else {
            async function sendcurImage() {
              let url = "/api/content/contentservice/contentToolFileUpload";
              let response = await props.authenticatedApiCall("post", url, data);
              if (response && response.status === StatusCodes.OK && response.data.result) {
                response.data.result.map((res) => {
                  return resdata.push(props.currentUser.config.s3BucketBaseUrl + res.Key);
                });
                if (typeof (values.content.courseimage) !== "string") {
                  sendingCurrvalue.content.courseimage = resdata[count];
                  count++;
                }
                if (values.chapter) {
                  values.chapter.map((chapter, index) => {
                    if (typeof (values.chapter[index].chapterimage) !== "string") {
                      sendingCurrvalue.chapter[index].chapterimage = resdata[count];
                      count++;
                    }
                    values.chapter[index].screen.map((screen, index1) => {
                      if (typeof (sendingCurrvalue.chapter[index].screen[index1].image) !== "string") {
                        sendingCurrvalue.chapter[index].screen[index1].image = resdata[count];
                        count++;
                      }
                    });
                  });
                }
                sendCurriculumdata();
              } else {
                setLoad(false);
                imageerror();
              }
            }
            sendcurImage();
          }
        }
        }>
       {({ values, handleChange, setFieldError, validateForm, errors, touched,}) => (
            <Form>
             <div className={classes.main}>
              <div className={classes.holder}>
                     <GridContainer>
                     <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Resourceid setFieldErrors={setFieldError} disabled={handleDisable}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Trigger triggeroptions={triggercurValue}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <CategoryTag categoryoption={categorytagValue}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <TopicTag topictagoption={TopictagcurrValue}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <Fieldtext name={"content[coursetitle]"} label="Course Title *" disabled={false}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Fieldtext name={"veevacontentid"} label="Veeva Content ID*" disabled={true}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <DiseaseSegment diseaseSegmentoptions={diseaseSegmentcurrValue}/>
                  </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Persona personaoptions={personaCurValue}/>
                </GridItem>
                    <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                            <Typography className={classes.gridHeader}>
                            <b className={classes.clr_title}>
                              {`Add Course Image *`}
                            </b>
                        </Typography>
                          <Field
                          name={"content[courseimage]"}
                          type="text"
                          component={File}
                          variant="filled"
                          onChange={handleChange}
                          className={classes.inputItem}
                          label={`courseimage*`}
                        />
                    {errors.content && touched.content && errors.content.courseimage && touched.content.courseimage ?
                      <p className={classes.errormessage}>{errors.content.courseimage}</p> : ""}
                      </GridItem>
                          <GridItem md={12} lg={12} sm={12} xs={12} ></GridItem>
                      <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                     <AreaField name={"content[introductionmessage]"}  InputProps={{ multiline: true, rows: 5 }} label="Course Introduction Message *"/>
                    </GridItem>
                    <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                    <AreaField name={"content[conclusionmessage]"}  InputProps={{ multiline: true, rows: 5 }} label="Course Conclusion Message *"/>
                  </GridItem>
                    <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                    <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Chapter *
                      </b>
                    </Typography>
                    </GridItem>
                      <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                        <FieldArray
                          name="chapter"
                         render={arrayHelpers => (
                         <div>
                         {values.chapter && values.chapter.length > 0 &&
                           values.chapter.map((value, index) => (
                            <Card>
                          <GridContainer key={index}>
                          <GridContainer className={classes.chapterheading}>
                          <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom} >
                            <br/>
                          <Typography className={classes.gridHeader}>
                          <b className={classes.clr_title} style={{paddingLeft:"25px"}} >
                         {`Chapter ${index+1} `}
                         </b>
                    </Typography>
                    </GridItem>
                    <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom} >
                    <br/>
                      <Tooltip  placement="top" arrow classes={{ tooltip: classes.lightTooltipTimeToTake + " " + "displayMedicationToolTipArrow"}} title={<GridContainer key={index} className={classes.adherencePopBdy}>
                      <GridItem md={10} style={{color:"#fff",textAlign:"center"}}>{`Chapter ${index+1}`}</GridItem></GridContainer>}>
                      <button className={classes.DeleteUser} type="button" onClick={() => arrayHelpers.remove(index)}>
                      <DeleteIcon style={{color:"rgb(177, 2, 34)"}}/> </button></Tooltip>
                      </GridItem>
                        </GridContainer>
                            <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                            <Typography className={classes.gridHeader} style={{paddingTop:"20px"}}>
                            <b className={classes.clr_title}>
                              {`Add Chapter Image ${index+1}*`}
                            </b>
                        </Typography>
                        <Field
                          name={`chapter.${index}.chapterimage`}
                          type="text"
                          component={File}
                          variant="filled"
                          onChange={handleChange}
                          className={classes.inputItem}
                          label={`chapterimage ${index}*`}
                        />
                      </GridItem>
                         <GridItem md={8} lg={8} sm={12} xs={12} style={{paddingTop:"70px"}} className={classes.paddingBottom}>
                         <Field
                           name={`chapter.${index}.title`}
                           type="text"
                           component={Textfield}
                           variant="filled"
                           onChange={handleChange}
                           label={`Chapter Title ${index+1} *`}
                           className={classes.inputItem}
                         />
                      </GridItem>
                        <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                          <Typography className={classes.gridHeader}>
                          <b className={classes.clr_title}>
                            Screen
                         </b>
                       </Typography>
                        </GridItem>
                          <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                        <FieldArray
                          name={`chapter.${index}.screen`}
                         render={arrayHelpers => (
                         <div>
                         {values.chapter[index].screen && values.chapter[index].screen.length > 0 &&
                          values.chapter[index].screen.map((screenvalue, index1) => (
                         <div style={{marginBottom:"10px",border:"5px solid rgb(243, 244, 245)"}} key={index1}>
                        <GridContainer>
                        <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                            <br/><br/>
                          <Typography className={classes.gridHeader}>
                          <b className={classes.clr_title}>
                         {`Screen ${index1+1} `}
                         </b>
                    </Typography>
                    </GridItem>
                      <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                            <br/><br/>
                          <Tooltip  placement="top" arrow classes={{ tooltip: classes.lightTooltipTimeToTake + " " + "displayMedicationToolTipArrow"}}
                                        title={<GridContainer key={index} className={classes.adherencePopBdy}>
                                               <GridItem md={10} style={{color:"#fff",textAlign:"center"}}>{`Screen ${index1+1}`}</GridItem></GridContainer>}>
                          <button className={classes.DeleteUser} type="button"  onClick={() => arrayHelpers.remove(index1)}>
                          <DeleteIcon style={{color:"rgb(177, 2, 34)"}}/> </button></Tooltip>
                           </GridItem>
                        <GridItem md={3} lg={3} sm={12} xs={12} className={classes.paddingBottom}>
                            <Typography className={classes.gridHeader}>
                            <b className={classes.clr_title}>
                              {`Add Screen Image ${index1+1}*`}
                            </b>
                        </Typography>
                         <Field
                          name={`chapter.${index}.screen.${index1}.image`}
                          type="text"
                          component={File}
                          variant="filled"
                          onChange={handleChange}
                          className={classes.inputItem}
                          label={`screen image ${index1}*`}
                        />
                      </GridItem>
                        <GridItem md={9} lg={9} sm={12} xs={12}  className={classes.paddingBottom}>
                         <Field
                           name={`chapter.${index}.screen.${index1}.title`}
                           type="text"
                           component={Textfield}
                           variant="filled"
                           onChange={handleChange}
                           label={`Screen Title ${index1+1} *`}
                           className={classes.inputItem}
                         />
                            <br/>
                         <Field
                           name={`chapter.${index}.screen.${index1}.description`}
                           type="text"
                           component={Textfield}
                           variant="filled"
                           onChange={handleChange}
                           className={classes.inputItem}
                          InputProps={{ multiline: true, rows:8 }}
                          label={`Screen Description ${index1+1} *`}
                         /><br/>
                          <Button onClick={handlepop} className={classes.cancelBtn} style={{marginLeft:"0px"}} >Sample Rich Text Editor</Button>
                         </GridItem>
                               </GridContainer>
                              </div>
                            ))}
                             <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                             <button
                           className={classes.createUser}
                           style={{padding:"10px"}}
                          type="button"
                          onClick={() => arrayHelpers.push( {
                            type: "text",
                            image:"",
                            title: "",
                            screenid: 1,
                            description: "",
                            displayorder: 1
                            } )}
                          >
                           Add Screen
                         </button>
                         </GridItem>
                             </div>
                         )}
                          />
                           </GridItem>
                       </GridContainer>
                          </Card>
                            ))}
                             <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom} style={{paddingLeft: "30px",}}>
                             <button className={classes.createUser} style={{padding:"10px"}} type="button" onClick={() => arrayHelpers.push( { title: "", chapterid: 1, screen: [ { type: "text", image: "", title: "", screenid: 1, description: "", displayorder: 1 } ], chapterimage:"", displayorder: 1 } )} >
                           Add Chapter
                         </button>
                         </GridItem>
                             </div>
                         )}
                          />
             </GridItem>
                </GridContainer>
             </div>
              </div>
                <Paper style={{ marginTop: "40px", width: "100%",boxShadow:"none",padding:"15px"}}>
                <Grid container style={{paddingBottom:'5px'}}>
                  <Grid item lg={9} md={9} sm={6} xs={6} style={{ width: '100%', textAlign: 'right' }}>
                    <Button onClick={handlePreview} className={classes.cancelBtn} >Preview</Button>
                      {openpopup&&<JsonPreview open={open} handleClose={handleClose} value={values}  name="curriculum" setChapterPreview={setChapterPreviewdata}/>}
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={6} style={{ width: '100%' }}>
                    <Button className={classes.createUser} onClick={() => validateForm().then(arg => { console.log(arg); })} type="submit" disabled={disablecursubmit}  > 
                    {load && <CircularProgress color="primary" style={{position: "absolute",right: "40%",top:"-140%"}} />}{"SUBMIT"} </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Form>
          )}
</Formik>
{openpop &&<SuccessDialog successButton={InactivatePatientButton1}   HeaderText={errorMessage} BodyText={Message}  dismiss={handleCloseDialog} />}
{newchapterpreview&&<ChapterPreview open={open} handleClose={handleClosechapter} value={chapterpreviewdata}/>}
{SucessFieldcur?props.location.state.detail?<SuccessDialog successButton={InactivatePatientButton} HeaderText={"Success"} BodyText={UpdatedMessage} dismiss={handleCloseDialogcur}/>
:<SuccessDialog successButton={InactivatePatientButton} HeaderText={"Success"} BodyText={SuccessMessage} dismiss={handleCloseDialog}/>:""}
 {Errorclosecur&&<ErrorDialog successButton={InactivatePatientButton1}  HeaderText={errorMessage1}  dismiss={ handleErrorUsercur}/>}
 {ImageErrorclosecur&&<ErrorDialog successButton={InactivatePatientButton1}  HeaderText={imageerrormessage}  dismiss={ handleErrorUsercur}/>}
</div>
   );
  };


export default (withStyles()(AuthenticatedPage()(AddCurriculum)));